type LocationTag = { id: string; name: string; color: string | null };

export function LocationTagBadges({ tags = [], compact = false }: { tags?: LocationTag[]; compact?: boolean }) {
  if (!tags.length) return null;
  const shown = compact ? tags.slice(0, 2) : tags;
  return <span className={`location-tag-badges${compact ? " location-tag-badges--compact" : ""}`} aria-label="Location tags" title={compact ? tags.map(tag => tag.name).join(" · ") : undefined}>
    {shown.map(tag => <span className="location-tag-badge" key={tag.id} title={tag.name}>
      <span className="location-tag-dot" style={{ backgroundColor: tag.color || "#64748b" }} aria-hidden="true" />
      <span className="location-tag-name">{tag.name}</span>
    </span>)}
    {compact && tags.length > shown.length && <span className="location-tag-badge location-tag-count" aria-label={`${tags.length - shown.length} more location tags`}>+{tags.length - shown.length}</span>}
  </span>;
}
